import { render, staticRenderFns } from "./project-detail-electric.vue?vue&type=template&id=6ef58bb4&scoped=true&"
import script from "./project-detail-electric.vue?vue&type=script&lang=js&"
export * from "./project-detail-electric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef58bb4",
  null
  
)

export default component.exports